export enum ExamType {
  Contacts = "contacts",
  GlassesTryContacts = "glasses_try_contacts",
  GlassesNoTryContacts = "glasses_no_try_contacts",
  NoGlassesOrContacts = "no_glasses_or_contacts",
  GlassesAndContacts = "glasses_and_contacts",
}
